import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as projectApi from '../../lib/api/project';
import { trim } from 'lodash';

const [
  LIST_PROJECT_FILES,
  LIST_PROJECT_FILES_SUCCESS,
  LIST_PROJECT_FILES_FAILURE,
] = createRequestActionTypes('project/LIST_PROJECT_FILES');

export const listProjectFiles = createAction(
  LIST_PROJECT_FILES,
  (searchData) => ({ salesType: 'B', searchData }),
);
const listProjectFilesSaga = createRequestSaga(
  LIST_PROJECT_FILES,
  projectApi.getEstimateFiles,
);

const UNLOAD_FILES = 'project/UNLOAD_FILES';
export const unloadFiles = createAction(UNLOAD_FILES);

export function* projectFilesSaga() {
  yield takeLatest(LIST_PROJECT_FILES, listProjectFilesSaga);
}

const initialState = {
  files: null,
  error: null,
};

const projectFiles = handleActions(
  {
    [LIST_PROJECT_FILES_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      files: data.list.map((file) => ({
        id: file.fileUuid,
        fileUuid: file.fileUuid,
        filePartnerNm: file.filePartnerNm,
        filePartnerUuid: file.filePartnerUuid,
        fileNm: trim(file.fileNm),
        fileUrl: file.fileUrl,
        prjNo: file.prjNo,
        prjUuid: file.prjUuid,
        cstNm: file.cstNm,
        fileRegDt: file.fileRegDt,
        fileCrtDt: file.fileCrtDt,
        fileCrtNm: file.fileCrtNm,
      })),
      error: null,
    }),
    [LIST_PROJECT_FILES_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_FILES]: () => initialState,
  },
  initialState,
);

export default projectFiles;
